import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { CommonFunctionService ,UserPOSData} from "../../../../services/Common/common-function.service";
import { Validators, FormControl } from "@angular/forms";
import { ItemServiceService} from '../../../../POS/POSServices/Setup/item-service.service';
const swal = require('sweetalert');

@Component({
  selector: 'app-item-view',
  templateUrl: './item-view.component.html',
  styleUrls: ['./item-view.component.scss']
})
export class ItemViewComponent implements OnInit {
  noImageavalabel:boolean=false;
  noImageavalabel1:boolean=false;
  Imageavalabel:boolean=false;
  Imageavalabel1:boolean=false;
  categoryName:any;
  maxFileSize = 40000;
maxWidth = 200;
maxHeight = 200;
  content:any;
  imageurl:any;
  merchantdata: UserPOSData ;
  rows;
  PriceType;
  constructor(
    private router: Router,
    private commonfunction: CommonFunctionService,
    private service: ItemServiceService,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.merchantdata = this.commonfunction.getUserPOSData();
    this.getGetitemDetails();
  }
  getGetitemDetails() {
    let form = { merchantKeyId: "", id: "", PosSubscriptionId:"" };
    this.activatedRoute.params.subscribe(params => {
      console.log(params["id"]);
      console.log(params["merchantKeyId"]);
      form.id = params["id"];
      form.merchantKeyId = params["merchantKeyId"];
      form.PosSubscriptionId  = this.merchantdata.PosSubscriptionId;
      console.log("formdata---" + form);
    });   

    this.service.GetItemDetail(form).subscribe(result => {   
      console.log("result.Id---" + result);
      if (result.Id > 0) {
     
        this.content = result.Content;
        if(this.content ==null || this.content =='')
        {
          this.noImageavalabel=true;
          this.Imageavalabel=false;
        }
        else{
          this.noImageavalabel=false;
          this.Imageavalabel=true;

        }
        if(result.ImageFile!=null&&result.ImageFile!="")
        {
        this.imageurl = result.ImageFile;
        if(this.imageurl ==null || this.imageurl ==" ")
        {
          this.noImageavalabel1=true;
          this.Imageavalabel1=false;
        }
        else{
          this.noImageavalabel=false;
          this.Imageavalabel1=true;

        }
      }
     
       this.rows=result;
      this.categoryName=result.CategoryName;
   if(result.PriceType==0)
    {
      this.PriceType ="Fixed";
    }
    else if(result.PriceType==1)
    {
      this.PriceType="Variable" ;
    }
    else if(result.PriceType==2)
    {
      this.PriceType="Per Unit" ;
    }
      }
      
    });
 
  }

}
